import standard from '@/services/standard'
import Service from '@/services/Service'

/**
 * @typedef {Http}
 */
export default class Http extends Service {
  /**
   * @param {String} path
   * @param {Object} options
   * @param {Object} http
   */
  constructor(path, options = {}, http = null) {
    super(options)
    this.path = path
    this.http = http || standard
  }

  /**
   * @param {String} path
   * @param {Object} options
   */
  static build(path, options) {
    return new this(path, options)
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  get(url, data = {}) {
    return this.http
      .get(this.constructor.normalize(this.path, url), data)
      .then(this.constructor.then)
      .catch(this.constructor.catch)
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  post(url, data) {
    return this.http
      .post(this.constructor.normalize(this.path, url), data)
      .then(this.constructor.then)
      .catch(this.constructor.catch)
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @param {Object} config
   * @returns {*|Promise<any>}
   */
  post(url, data, config) {
    return this.http
      .post(this.constructor.normalize(this.path, url), data, config)
      .then(this.constructor.then)
      .catch(this.constructor.catch)
  }


  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  put(url, data) {
    return this.http
      .put(this.constructor.normalize(this.path, url), data)
      .then(this.constructor.then)
      .catch(this.constructor.catch)
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  patch(url, data) {
    return this.http
      .patch(this.constructor.normalize(this.path, url), data)
      .then(this.constructor.then)
      .catch(this.constructor.catch)
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  delete(url) {
    return this.http
      .delete(this.constructor.normalize(this.path, url))
      .then(this.constructor.then)
      .catch(this.constructor.catch)
  }

  /**
   * @param {Object} response
   * @returns {Object}
   */
  static then(response) {
    if (response.data && response.headers["content-type"].indexOf("application/json") !== -1) {
      return JSON.parse(response.data)
    }
    return response
  }

  /**
   * @param {Object} exception
   * @returns {Object}
   */
  static catch(exception) {
    if (typeof exception.response.data === 'string') {
      return Promise.reject(JSON.parse(exception.response.data))
    } else if (typeof exception.response.data === 'object') {
      try {
        return Promise.reject(JSON.parse(String.fromCharCode.apply(null, new Uint8Array(exception.response.data))))
      } catch (e) { console.error(e.message)}
    }
    return Promise.reject(exception)
  }

  /**
   * @param {String} start
   * @param {String} end
   * @returns {String}
   */
  static normalize(start, end) {
    return `${start}/${end}`.replace(/([^:]\/)\/+/g, '$1')
  }
}
